import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'csl-user-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-banner.component.css',
})
export class UserBannerComponent {
  userLastFirstName = input.required<string | null | undefined>();
  userRole = input<string | null | undefined>();
}
